import { Container, Row, Col } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import github from "../assets/img/github.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} sm={6}>
            <span className="footer-brand">Gabriel Nulman</span>
            <p>Software Engineer</p>
          </Col>
          <Col xs={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              {/* eslint-disable-next-line */}
              <a target="_blank" href="https://www.linkedin.com/in/gabriel-nulman/" aria-label="LinkedIn">
                <img src={navIcon1} alt="LinkedIn" width={'18px'} height={'18px'} />
              </a>
              {/* eslint-disable-next-line */}
              <a target="_blank" href="https://github.com/YoYoGavri" aria-label="GitHub">
                <img src={github} alt="GitHub" width={'26px'} height={'26px'} />
              </a>
            </div>
            <p>Copyright {new Date().getFullYear()} Gabriel Nulman. All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
